import { render } from "./QuestionnaireRadio.vue?vue&type=template&id=197244e4&scoped=true"
import script from "./QuestionnaireRadio.vue?vue&type=script&lang=js"
export * from "./QuestionnaireRadio.vue?vue&type=script&lang=js"

import "./QuestionnaireRadio.vue?vue&type=style&index=0&id=197244e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197244e4"]])

export default __exports__